import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-paragraph",
  "use": "icon-th-paragraph-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-paragraph\">\n<path d=\"M26 5H12C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21H17V26C17 26.2652 17.1054 26.5196 17.2929 26.7071C17.4804 26.8946 17.7348 27 18 27C18.2652 27 18.5196 26.8946 18.7071 26.7071C18.8946 26.5196 19 26.2652 19 26V7H22V26C22 26.2652 22.1054 26.5196 22.2929 26.7071C22.4804 26.8946 22.7348 27 23 27C23.2652 27 23.5196 26.8946 23.7071 26.7071C23.8946 26.5196 24 26.2652 24 26V7H26C26.2652 7 26.5196 6.89464 26.7071 6.70711C26.8946 6.51957 27 6.26522 27 6C27 5.73478 26.8946 5.48043 26.7071 5.29289C26.5196 5.10536 26.2652 5 26 5ZM17 19H12C10.4087 19 8.88258 18.3679 7.75736 17.2426C6.63214 16.1174 6 14.5913 6 13C6 11.4087 6.63214 9.88258 7.75736 8.75736C8.88258 7.63214 10.4087 7 12 7H17V19Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-paragraph.svg
// module id = BhLt
// module chunks = 84